

export const Createuserwithrole = async (
  username,
  firstName,
  lastName,
  email,
  role,
  payloadrole
) => {
  let addrole;
  if (role == "Client") {
    addrole = "/formsflow/formsflow-client";
  }
  if (role == "Clerk") {
    addrole = "/formsflow/formsflow-reviewer/clerk";
  }
  if (role == "Approver") {
    addrole = "/formsflow/formsflow-reviewer/approver";
  }

  const payload = {
    enabled: true,
    attributes: {},
    groups: [addrole],
    username: username,
    emailVerified: "",
    credentials: [
      {
        type: "password",
        value: "changeme",
        temporary: "true",
      },
    ],
    email: email,
    firstName: firstName,
    lastName: lastName,
  };

  let response = await fetch(
    `http://localhost:8080/auth/admin/realms/forms-flow-ai/users`,
    {
      method: "POST", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, *cors, same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      // credentials: 'same-origin', // include, *same-origin, omit
      Origin: "http://localhost:8080",
      headers: {
        "Content-Type": "application/json",
        Host: "localhost:8080",
        "Content-Length": JSON.stringify(payload).length,

        Authorization: process.env.REACT_APP_KEYCLOAK_MASTERREALM_TOKEN,

        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      redirect: "follow", // manual, *follow, error
      referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      body: JSON.stringify(payload), // body data type must match "Content-Type" header
    }
  );

  return response;
};

export const Deleteuser = async (userid) => {
  let temp;
  let response = await fetch(
    `http://localhost:8080/auth/admin/realms/forms-flow-ai/users/${userid}`,
    {
      method: "DELETE", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, *cors, same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      // credentials: 'same-origin', // include, *same-origin, omit
      Origin: "http://localhost:8080",
      headers: {
        "Content-Type": "application/json",
        Host: "localhost:8080",
        Authorization: process.env.REACT_APP_KEYCLOAK_MASTERREALM_TOKEN,

        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      redirect: "follow", // manual, *follow, error
      referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      //   body: JSON.stringify(payload), // body data type must match "Content-Type" header
    }
  )
    .then(() => {
      
      alert("user deleted successfully!!");
      temp=true;

     
    
    })
    .catch((err) => {
      console.log(err);
      temp=false;
      
    });

    return temp;
};

export const getkeycloakuserdata = async (userid) => {
  let response = await fetch(
    `http://localhost:8080/auth/admin/realms/forms-flow-ai/users/${userid}`,
    {
      method: "GET", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, *cors, same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      // credentials: 'same-origin', // include, *same-origin, omit
      Origin: "http://localhost:8080",
      headers: {
        "Content-Type": "application/json",
        Host: "localhost:8080",
        Authorization: process.env.REACT_APP_KEYCLOAK_MASTERREALM_TOKEN,

        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      redirect: "follow", // manual, *follow, error
      referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      //   body: JSON.stringify(payload), // body data type must match "Content-Type" header
    }
  );
  let data = await response.json();

  return data;
};

export const fetchrolendretrole = async (userid) => {
  let response = await fetch(
    `http://localhost:8080/auth/admin/realms/forms-flow-ai/users/${userid}/groups`,
    {
      method: "GET", // *GET, POST, PUT, DELETE, etc.
      Accept: "application/json",

      mode: "cors", // no-cors, *cors, same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      // credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        "Content-Type": "application/json",
        Host: "localhost:8080",
        "Sec-Fetch-Mode": "cors",
        "Sec-Fetch-Site": "same-site",

        //  "Remote Address": "[::1]:8080",

        Authorization: process.env.REACT_APP_KEYCLOAK_MASTERREALM_TOKEN,

        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      redirect: "follow", // manual, *follow, error
      referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url

      // body data type must match "Content-Type" header
    }
  );

  let data = await response.json();

  const rolefound = await data.find((data) => {
    if (data.path == "/formsflow/formsflow-reviewer/approver") {
      return data;
    }
    if (data.path == "/formsflow/formsflow-client") {
      return data;
    }
    if (data.path == "/formsflow/formsflow-reviewer/clerk") {
      return data;
    }

    if (data.path == "/formsflow/formsflow-designer") {
      return data;
    }
  });

  if (rolefound.path == "/formsflow/formsflow-reviewer/approver") {
    return "Approver";
  }
  if (rolefound.path == "/formsflow/formsflow-client") {
    return "Client";
  }
  if (rolefound.path == "/formsflow/formsflow-reviewer/clerk") {
    return "Clerk";
  }

  if (rolefound.path == "/formsflow/formsflow-designer") {
    return "Designer";
  }

  return "NO role assigned";
};

export const getCurrentSession = async (userid) => {
  let response = await fetch(
    `http://localhost:8080/auth/admin/realms/forms-flow-ai/users/${userid}/sessions`,
    {
      method: "GET", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, *cors, same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      // credentials: 'same-origin', // include, *same-origin, omit
      Origin: "http://localhost:8080",
      headers: {
        "Content-Type": "application/json",
        Host: "localhost:8080",
        Authorization: process.env.REACT_APP_KEYCLOAK_MASTERREALM_TOKEN,

        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      redirect: "follow", // manual, *follow, error
      referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      //   body: JSON.stringify(payload), // body data type must match "Content-Type" header
    }
  );
  let data = await response.json();

  return data;
};

export const editUserDetails = async (
  userid,
  createdTimestamp,
  username,
  firstName,
  lastName,
  email
) => {
  const payload = {
    id: userid,
    createdTimestamp: createdTimestamp,
    username: username,
    enabled: true,
    totp: false,
    emailVerified: false,
    email: email,
    firstName: firstName,
    lastName: lastName,
    disableableCredentialTypes: [],
    requiredActions: ["UPDATE_PASSWORD"],
    notBefore: 0,
    access: {
      manageGroupMembership: true,
      view: true,
      mapRoles: true,
      impersonate: true,
      manage: true,
    },
    attributes: {},
  };

  let response = await fetch(
    `http://localhost:8080/auth/admin/realms/forms-flow-ai/users/${userid}`,
    {
      method: "PUT", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, *cors, same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      // credentials: 'same-origin', // include, *same-origin, omit
      Origin: "http://localhost:8080",
      headers: {
        "Content-Type": "application/json",
        Host: "localhost:8080",
        "Content-Length": JSON.stringify(payload).length,

        Authorization: process.env.REACT_APP_KEYCLOAK_MASTERREALM_TOKEN,

        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      redirect: "follow", // manual, *follow, error
      referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      body: JSON.stringify(payload), // body data type must match "Content-Type" header
    }
  )
    .then((result) => {})
    .catch((err) => {
      console.log(err);
    });
};

export const DeleteRole = async (userid, roleid) => {
  let response = await fetch(
    `http://localhost:8080/auth/admin/realms/forms-flow-ai/users/${userid}/groups/${roleid}`,
    {
      method: "DELETE", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, *cors, same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      // credentials: 'same-origin', // include, *same-origin, omit
      Origin: "http://localhost:8080",
      headers: {
        "Content-Type": "application/json",
        Host: "localhost:8080",
        Authorization: process.env.REACT_APP_KEYCLOAK_MASTERREALM_TOKEN,

        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      redirect: "follow", // manual, *follow, error
      referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      //   body: JSON.stringify(payload), // body data type must match "Content-Type" header
    }
  )
    .then(() => {
    
    })
    .catch((err) => {
      console.log(err);
    });
};

export const editUserRole = async (userid, roleid) => {
  const payload = {
    realm: "forms-flow-ai",
    userId: userid,
    groupId: roleid,
  };

  let response = await fetch(
    `http://localhost:8080/auth/admin/realms/forms-flow-ai/users/${userid}/groups/${roleid}`,
    {
      method: "PUT", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, *cors, same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      // credentials: 'same-origin', // include, *same-origin, omit
      Origin: "http://localhost:8080",
      headers: {
        "Content-Type": "application/json",
        Host: "localhost:8080",
        "Content-Length": JSON.stringify(payload).length,

        Authorization: process.env.REACT_APP_KEYCLOAK_MASTERREALM_TOKEN,

        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      redirect: "follow", // manual, *follow, error
      referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      body: JSON.stringify(payload), // body data type must match "Content-Type" header
    }
  )
    .then((result) => {
      console.log(result);
      alert("role updated successfully!!!")
      window.location.reload();
    })
    .catch((err) => {
      console.log(err);
    });
};

export const getGroupsUserId = async () => {
  let response = await fetch(
    `http://localhost:8080/auth/admin/realms/forms-flow-ai/groups?first=0&max=20`,
    {
      method: "GET", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, *cors, same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      // credentials: 'same-origin', // include, *same-origin, omit
      Origin: "http://localhost:8080",
      headers: {
        "Content-Type": "application/json",
        Host: "localhost:8080",
        Authorization: process.env.REACT_APP_KEYCLOAK_MASTERREALM_TOKEN,

        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      redirect: "follow", // manual, *follow, error
      referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      //   body: JSON.stringify(payload), // body data type must match "Content-Type" header
    }
  );
  let data = await response.json();

  return data;
};
